import React, { useEffect, useRef, useState } from "react";
import "../../assets/styles/local/SeeBuildingBlockPopup.css";
import closeIcon from "../../assets/icons/x-circle.svg";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const SeeBuildingBlock = (props) => {
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("My-Plan").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  return (
    <div className="Popup-page-open p-4">
      <table class="custom-table-style">
        <thead>
          <tr className="see-building-block">
            <th className="block-text">
              {/* BUILDING BLOCKS */}
              {t("BUILDING BLOCKS")}
            </th>
            <th className="combo-pink">
              {/* PRODUCTION */}
              {t("PRODUCTION")}
            </th>
            <th className="gray-text">
              {/* CONSTRUCTION */}
              {t("CONSTRUCTION")}
            </th>
            <th className="combo-pink">
              {/* LOGISTIC */}
              {t("LOGISTIC")}
            </th>
            <th className="gray-text">
              {/* SERVICES */}
              {t("SERVICES")}
            </th>
            <th className="">
              <img
                src={closeIcon}
                alt=""
                className="close-pointer"
                onClick={() => {
                  props.setBuildingPopupShow2(false);
                }}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="tablet-form-black-text">
              <b>
                {/* Essentials */}
                {t("Essentials")}
              </b>
            </td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tablet-form"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Login, forgot password, keep me logged in, user log validation */}
              {t(
                "Login, forgot password, keep me logged in, user log validation Private Cloud Basic System, Secured login, Roles & Authorization",
              )}
              {/* <br /> */}
              {/* Private Cloud Basic System, Secured login, Roles & Authorization */}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Agile Planboard - Dispatching board, Tickets */}
              {t("Agile Planboard - Dispatching board, Tickets")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Tickets with Checklist/steps */}
              {t("Tickets with Checklist/steps")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* MyTask ToDo App */}
              {t("MyTask ToDo App")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Contact Relation Management (CRM) */}
              {t("Company Face Book")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Co-worker / Human Resource Management */}
              {t("Co-worker / Human Resource Management")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Company Face Book */}
              {t("Company Face Book")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Team Chat */}
              {t("Team Chat")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Translation - Semantics */}
              {t("Translation - Semantics")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Notification */}
              {t("Notification")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Personal Profile */}
              {t("Personal Profile")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Translation - Semantics */}
              {t("Translation - Semantics")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>

          <tr>
            <td className="tablet-form-black-text">
              <b>
                {/* Project Operation */}
                {t("Project Operation")}
              </b>
            </td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tablet-form"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Planning board with calender display */}
              {t("Planning board with calender display")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Project Management */}
              {t("Project Management")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Project Planning */}
              {t("Project Planning")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Project Documents */}
              {t("Project Documents")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Project invoicing */}
              {t("Project invoicing")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Project Finance */}
              {t("Project Finance")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Project Calculation & Quotation */}{" "}
              {t("Project Calculation & Quotation")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Project Quotation with PDF Print option */}{" "}
              {t("Project Quotation with PDF Print option")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>

          <tr>
            <td className="tablet-form-black-text">
              <b>
                {/* Human Resource */}
                {t("Human Resource")}
              </b>
            </td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tablet-form"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Time registration app (extension on the My Task) */}{" "}
              {t("Time registration app (extension on the My Task)")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Timesheets - Track time manually */}{" "}
              {t("Timesheets - Track time manually")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Approve hours by manager/owner  */}{" "}
              {t("Approve hours by manager/owner")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Track time under the ticket and widget */}{" "}
              {t("Track time under the ticket and widget")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>

          <tr>
            <td className="tablet-form-black-text">
              <b>
                {/* Settings */}
                {t("Settings")}
              </b>
            </td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tablet-form"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Info about the Company - language, address, time */}{" "}
              {t("Info about the Company - language, address, time")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>

          <tr>
            <td className="tablet-form-black-text">
              <b>
                {/* Stock */}
                {t("Stock")}
              </b>
            </td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tablet-form"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Warehouse management App */}{" "}
              {t("Warehouse management App")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* List of purchasing orders */}{" "}
              {t("List of purchasing orders")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Suppliers */}
              {t("Suppliers")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Purchasing orders processing(add purchasing) */}{" "}
              {t("Purchasing orders processing(add purchasing)")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Add to warehouse & Assign to project */}{" "}
              {t("Add to warehouse & Assign to project")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Project order picking  */}{" "}
              {t("Project order picking")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Count stock */}
              {t("Count stock")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Totaly stock available */}{" "}
              {t("Totally stock available")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Purchasing per project */}{" "}
              {t("Purchasing per project")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick">✓</td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>

          <tr>
            <td className="tablet-form-black-text">
              <b>
                {/* Sales */}
                {t("Sales")}
              </b>
            </td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tablet-form"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Product and Service Catalogue */}{" "}
              {t("Product and Service Catalogue")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Quotation and Calculation (Quotes page) */}{" "}
              {t("Quotation and Calculation (Quotes page)")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Digital Signature on Quotation Approval */}{" "}
              {t("Digital Signature on Quotation Approval")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Sales Pipeline Stages */}{" "}
              {t("Sales Pipeline Stages")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Customer-oriented tariff structure */}{" "}
              {t("Customer-oriented tariff structure")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Management of Additional Work & provisional */}{" "}
              {t("Management of Additional Work & provisional")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick">✓</td>
            <td className="tick"></td>
          </tr>

          <tr>
            <td className="tablet-form-black-text">
              <b>
                {/* Co-Workers */}
                {t("Co-Workers")}
              </b>
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tablet-form"></td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tablet-form"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* HRM Payroll management & settings */}{" "}
              {t("HRM Payroll management & settings")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>

          <tr>
            <td className="tablet-form-black-text">
              <b>
                {/* Advanced Planning */}
                {t("Advanced Planning")}
              </b>
            </td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tablet-form"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {t("Teams & Team planning on project (without )")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Co-woker(Schedule) */}
              {t("Co-worker(Schedule)")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Equipment management & planning on project */}{" "}
              {t("Equipment management & planning on project")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Projects Planning (Gantt chart) with dependencies */}{" "}
              {t("Projects Planning (Gantt chart) with dependencies")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Control Management of Assets (Installations) */}{" "}
              {t("Control Management of Assets (Installations)")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Product Assembly */}
              {t("Product Assembly")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Dispatch Board for Advanced Production */}{" "}
              {t("Dispatch Board for Advanced Production")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>

          <tr>
            <td className="tablet-form-black-text">
              <b>
                {/* Financial/ Admin */}
                {t("Financial/ Admin")}
              </b>
            </td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tablet-form"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Invoicing from the project card */}{" "}
              {t("Invoicing from the project card")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Integration with Bookkeeping */}{" "}
              {t("Integration with Bookkeeping")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* BI Dashboard */}
              {t("BI Dashboard")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* List of invoice and proforma */}{" "}
              {t("List of invoice and proforma")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Performance voucher (PO number on the bait of) */}{" "}
              {t("Performance voucher (PO number on the bait of)")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>

          <tr>
            <td className="tablet-form-black-text">
              <b>
                {/* Inventory */}
                {t("Inventory")}
              </b>
            </td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tablet-form"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Product and Service information Management */}{" "}
              {t("Product and Service information Management")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Active stock management */}{" "}
              {t("Active stock management")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Just In Time (JIT) order advice */}{" "}
              {t("Just In Time (JIT) order advice")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>

          <tr>
            <td className="tablet-form-black-text">
              <b>
                {/* Route Planning */}
                {t("Route Planning")}
              </b>
            </td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tablet-form"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Route tracking (extension on the My task ToDo) */}{" "}
              {t("Route tracking (extension on the My task ToDo)")}
            </td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>

          <tr>
            <td className="tablet-form-black-text">
              <b>
                {/* Support & Marketing */}{" "}
                {t("Support & Marketing")}
              </b>
            </td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tablet-form"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Spire Pluse- Direct chat support for end-users */}{" "}
              {t("Spire Pluse- Direct chat support for end-users")}
            </td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>

          <tr>
            <td className="tablet-form-black-text">
              <b>
                {/* Quality Assurance */}
                {t("Quality Assurance")}
              </b>
            </td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tablet-form"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* From builder without rules */}{" "}
              {t("From builder without rules")}
            </td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>

          <tr>
            <td className="tablet-form-black-text">
              <b>
                {/* Workflow Automation */}{" "}
                {t("Workflow Automation")}
              </b>
            </td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tablet-form"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Workflow automation builder */}{" "}
              {t("Workflow automation builder")}
            </td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>

          <tr>
            <td className="tablet-form-black-text">
              <b>
                {/* Integration */}
                {t("Integration")}
              </b>
            </td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tablet-form"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* office suite MS Office 365 integration */}
              {t("office suite MS Office 365 integration")}
            </td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Google Workspace integration */}{" "}
              {t("Google Workspace integration")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* Custom Pulse Widget- Direct support for Client */}
              {t("Custom Pulse Widget- Direct support for Client")}
            </td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>

          <tr>
            <td className="tablet-form-black-text">
              <b>
                {/* Bookkeeping  */} 
                {t("Bookkeeping")}
              </b>
            </td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tick-pink-color"></td>
            <td className="tablet-form"></td>
            <td className="tablet-form"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              {/* QuickBooks Essentials */}
              {t("QuickBooks Essentials")}
            </td>
            <td className="tick-pink-color">✓</td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
          <tr>
            <td className="tablet-form">
              Extra Admin for an entity
              {/* {FetchTranslationList[122]?.translation} */}
            </td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick-pink-color"></td>
            <td className="tick"></td>
            <td className="tick"></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SeeBuildingBlock;
